import { IApiLink } from "@/types"
import DepreciationPeriod, { IGetDepreciationPeriodDto } from "./DepreciationPeriod"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"

export interface IGetDepreciationPeriodsDto {
    entities: IGetDepreciationPeriodDto[]
    links?: IApiLink[]
}

export default class DepreciationPeriods {
    list: DepreciationPeriod[]
    linkCreate?: IApiLink
    linkGetAssetCategories?: IApiLink

    constructor({
        entities,
        links,
    }: IGetDepreciationPeriodsDto) {
        this.list = entities.map(dto => new DepreciationPeriod(dto))

        if (links) {
            this.linkCreate = links.find(lnk => lnk.entity === ApiLinkEntity.depreciationPeriod && lnk.rel === ApiLinkRel.partialUpdate)
            this.linkGetAssetCategories = links.find(lnk => lnk.entity === ApiLinkEntity.assetCategory && lnk.rel === ApiLinkRel.all)
        }
    }

    get canCreate(): boolean {
        return !!this.linkCreate
    }
}
